
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 2","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 19.57 17.69"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"fill":"none","d":"M0 0h19.57v17.69H0z"}})])]),_c('g',{attrs:{"data-name":"Layer 1"}},[_c('g',{attrs:{"clip-path":"url(#a)"}},[_c('path',{attrs:{"d":"M10.71.04c-4.87 0-8.83 3.95-8.83 8.82v.06H-.04l3.79 5.23 3.79-5.23H5.43v-.06c0-2.91 2.37-5.27 5.27-5.27s5.27 2.37 5.27 5.27-2.37 5.27-5.27 5.27c-1.26 0-2.48-.45-3.44-1.28l-.47-.41-2.1 2.89.42.34c1.57 1.29 3.56 2 5.59 2 4.86 0 8.82-3.96 8.82-8.82S15.57.04 10.71.04zm0 16.5c-1.59 0-3.14-.5-4.43-1.41l.73-1.01c1.08.76 2.37 1.18 3.7 1.18 3.54 0 6.42-2.88 6.42-6.42s-2.88-6.42-6.42-6.42-6.42 2.88-6.42 6.42c0 .23.01.47.04.69l.06.51h.92l-1.54 2.13-1.54-2.13h.89l-.05-.62c-.01-.19-.02-.39-.02-.59 0-4.23 3.44-7.67 7.67-7.67s7.67 3.44 7.67 7.67-3.44 7.67-7.67 7.67z"}})]),_c('path',{attrs:{"d":"M10.15 4.69v2.45c-.72.24-1.23.92-1.23 1.71a1.81 1.81 0 002.81 1.51l1.29.96.69-.92-1.27-.95c.07-.19.1-.39.1-.6 0-.8-.52-1.47-1.23-1.71V4.69h-1.15zm.57 4.83c-.36 0-.66-.3-.66-.66s.3-.66.66-.66.66.3.66.66-.3.66-.66.66z"}})])])
          )
        }
      }
    